import { render, staticRenderFns } from "./ManageStore.vue?vue&type=template&id=9080ab16&scoped=true"
import script from "./ManageStore.vue?vue&type=script&lang=js"
export * from "./ManageStore.vue?vue&type=script&lang=js"
import style0 from "./ManageStore.vue?vue&type=style&index=0&id=9080ab16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9080ab16",
  null
  
)

export default component.exports